(function () {
  const pageCache = new Map();

  async function fetchPage(url) {
    if (pageCache.has(url)) return pageCache.get(url);
    const promise = fetch(url, { credentials: 'same-origin' })
      .then((res) => {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then((html) => new DOMParser().parseFromString(html, 'text/html'));
    pageCache.set(url, promise);
    return promise;
  }

  function extractSectionStyles(doc, sectionId) {
    const styles = doc.querySelectorAll('style');
    for (const styleEl of styles) {
      if (styleEl.textContent.includes('#' + sectionId)) {
        const match = styleEl.textContent.match(
          new RegExp('#' + sectionId.replace(/[-_]/g, '[\\-_]') + '\\s+\\.size-chart\\s*\\{([^}]+)\\}')
        );
        if (match) return match[1].trim();
      }
    }
    return '';
  }

  function parseTypes(str) {
    if (!str) return [];
    return str
      .split(/\n+/)
      .map((s) => s.trim().toLowerCase())
      .filter(Boolean);
  }

  function pickSection(doc, productType, fallbackAnchor) {
    const sections = Array.from(doc.querySelectorAll('[data-size-chart-section]'));
    if (sections.length === 0) return null;

    const normalizedType = (productType || '').trim().toLowerCase();

    if (normalizedType) {
      for (const sec of sections) {
        const types = parseTypes(sec.dataset.productTypes || '');
        if (types.includes(normalizedType)) return sec;
      }
    }

    if (fallbackAnchor) {
      const byAnchor = doc.getElementById(fallbackAnchor);
      if (byAnchor && byAnchor.matches('[data-size-chart-section]')) return byAnchor;
    }

    const defaultSection = sections.find((s) => s.dataset.isDefault === 'true');
    if (defaultSection) return defaultSection;

    return null;
  }

  async function loadChart(target) {
    if (target.dataset.loaded === 'true') return;
    target.dataset.loaded = 'true';

    const url = target.dataset.pageUrl;
    const productType = target.dataset.productType || '';
    const forcedAnchor = (target.dataset.defaultAnchor || '').trim();

    if (!url) {
      showError(target, 'Size guide page is not set. Pick one in the Theme Editor under the Size Guide (smart popup) block.');
      return;
    }

    try {
      const doc = await fetchPage(url);

      let wrapper;
      if (forcedAnchor) {
        wrapper = doc.getElementById(forcedAnchor);
        if (!wrapper) {
          showError(target, 'Could not find a Size Chart with Anchor ID "' + forcedAnchor + '" on the linked page.');
          return;
        }
      } else {
        wrapper = pickSection(doc, productType, '');
        if (!wrapper) {
          showError(target, 'No size chart is set up for this product type. In the Theme Editor, edit a Size Chart section on the linked page and tick "Use as default chart".');
          return;
        }
      }

      const chart = wrapper.querySelector('.size-chart');
      if (!chart) {
        showError(target, 'Found the section but no chart inside it.');
        return;
      }

      const sectionWrapper = wrapper.closest('[id^="shopify-section-"]');
      const sectionId = sectionWrapper ? sectionWrapper.id : null;
      const inlineVars = sectionId ? extractSectionStyles(doc, sectionId) : '';

      const clone = chart.cloneNode(true);
      const details = clone.querySelector('.size-chart__details');
      if (details) {
        details.setAttribute('open', '');
        const icon = details.querySelector('.icon-plus-alt');
        if (icon) icon.remove();
        const summary = details.querySelector('summary');
        if (summary) {
          const div = document.createElement('div');
          div.className = summary.className;
          while (summary.firstChild) div.appendChild(summary.firstChild);
          summary.parentNode.replaceChild(div, summary);
        }
      }
      if (inlineVars) clone.setAttribute('style', inlineVars);

      target.innerHTML = '';
      target.appendChild(clone);
    } catch (err) {
      target.dataset.loaded = 'false';
      showError(target, 'Could not load the size guide. Please try again.');
    }
  }

  function showError(target, message) {
    target.innerHTML = '<p class="smart-size-guide__error">' + message + '</p>';
  }

  function observeModal(target) {
    const modal = target.closest('modal-dialog');
    if (!modal) return;
    if (modal.hasAttribute('open')) loadChart(target);
    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.attributeName === 'open' && modal.hasAttribute('open')) {
          loadChart(target);
        }
      }
    });
    observer.observe(modal, { attributes: true, attributeFilter: ['open'] });
  }

  function init() {
    const targets = document.querySelectorAll('[data-smart-size-guide-target]');
    targets.forEach(observeModal);
    const prefetch = () => targets.forEach((t) => loadChart(t));
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(prefetch, { timeout: 2000 });
    } else {
      setTimeout(prefetch, 500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
